var WalletEvent;
(function(WalletEvent2) {
  WalletEvent2["AGREED_COMPLIANCE"] = "onAgreedCompliance";
  WalletEvent2["BONUS_APPLIED"] = "onBonusApplied";
  WalletEvent2["BONUS_FAILED"] = "onBonusFailed";
  WalletEvent2["BONUS_FORFEITED"] = "onBonusForfeited";
  WalletEvent2["DEPOSIT"] = "deposit";
  WalletEvent2["WITHDRAWAL"] = "withdrawal";
  WalletEvent2["DEPOSIT_ERROR"] = "onDepositError";
  WalletEvent2["WITHDRAWAL_ERROR"] = "onWithdrawalError";
  WalletEvent2["DEPOSIT_SUCCESS"] = "onDepositSuccess";
  WalletEvent2["WITHDRAWAL_SUCCESS"] = "onWithdrawalSuccess";
  WalletEvent2["DEPOSIT_STARTED"] = "onDepositStarted";
  WalletEvent2["WITHDRAWAL_STARTED"] = "onWithdrawalStarted";
  WalletEvent2["LIVE_HELP_CALLED"] = "onLiveHelpCalled";
  WalletEvent2["SELECT_BONUS"] = "selectBonus";
  WalletEvent2["SELECT_DEPOSIT_ACCOUNT"] = "selectDepositAccount";
  WalletEvent2["SELECT_WITHDRAWAL_ACCOUNT"] = "selectWithdrawalAccount";
  WalletEvent2["SET_DEPOSIT_METHOD"] = "setDepositMethod";
  WalletEvent2["SET_WITHDRAWAL_METHOD"] = "selectWithdrawalMethod";
  WalletEvent2["SET_DEPOSIT_AMOUNT"] = "setDepositAmount";
  WalletEvent2["SET_WITHDRAWAL_AMOUNT"] = "setWithdrawalAmount";
  WalletEvent2["SET_DEPOSIT_CVC"] = "setDepositCVC";
  WalletEvent2["SET_DEPOSIT_EXPIRY_DATE"] = "setDepositExpiryDate";
  WalletEvent2["SET_DEPOSIT_ENCRYPTED_CREDITCARD"] = "setDepositEncryptedCreditcard";
  WalletEvent2["SET_DEPOSIT_NETELLER_ACCOUNT"] = "setDepositNetellerAcount";
  WalletEvent2["SET_DEPOSIT_NETELLER_SECURE_ID"] = "setDepositNetellerSecureId";
  WalletEvent2["SET_WITHDRAWAL_BANK_FIELDS"] = "setWithdrawalBankFields";
  WalletEvent2["WITHDRAWAL_CANCELLED"] = "onWithdrawalCancelled";
  WalletEvent2["SHOW_BONUS_TERMS"] = "showBonusTerms";
  WalletEvent2["TRANSITION"] = "transition";
  WalletEvent2["RESIZE"] = "onContentResized";
  WalletEvent2["CLOSE"] = "close";
  WalletEvent2["READY"] = "onReady";
})(WalletEvent || (WalletEvent = {}));

export { WalletEvent };
